import { Navigate, useMatch } from 'react-location'
import { useAuth } from '../containers/AuthContainer'

interface Props {
  render: () => JSX.Element | null
  loginPath?: string
}

function PrivateRouteRPC(props: Props): JSX.Element | null {
  const match = useMatch()
  const { isAuthenticated } = useAuth()

  const { loginPath = '/login', render } = props
  // if user is not auth redirect to loginPAth
  if (!isAuthenticated()) return <Navigate to={loginPath} from={match} />

  return render()
}

export default PrivateRouteRPC
